import { Box } from "@mui/material";
import ListCreateTab from "components/ListCreateTab";
import AdVideoCreate from "pages/advertisement/ad_videos/AdVideoCreate";
import AdVideoList from "pages/advertisement/ad_videos/AdVideoList";
import React from "react";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import VideoCallIcon from "@mui/icons-material/VideoCall";

const AdVideoManagement = () => {
  return (
    <Box sx={{ display: "flex", flex: 1 }}>
      <ListCreateTab
        mod="Ads video"
        viewIcon={<OndemandVideoIcon />}
        createIcon={<VideoCallIcon />}
        createChildren={<AdVideoCreate />}
        listChildren={<AdVideoList />}
      />
    </Box>
  );
};

export default AdVideoManagement;
